export type ViewRouteMatch = {
  route: {
    path?: string;
  };
};

export const getViewName = (
  matches: ViewRouteMatch[],
  pathname: string,
): string => {
  const pattern = matches.reduce((acc, match) => {
    const { path } = match.route;

    if (!path) {
      return acc;
    }

    return path.startsWith('/') ? path : `${acc}/${path}`;
  }, '');

  return pattern.replace(/\/{2,}/g, '/') || pathname;
};
